export function mixin(Hop) {
    Hop.pageTop = () =>
        Hop.window.pageYOffset !== undefined
            ? Hop.window.pageYOffset
            : (Hop.document.documentElement || Hop.document.body.parentNode || Hop.document.body).scrollTop;
}
